import {
    Component,
    EventEmitter,
    HostBinding,
    inject,
    Input,
    Output,
} from '@angular/core';
import { IconEnum } from 'shared/design-system/data-access/icon';
import { ColorEnum } from 'shared/design-system/data-access/theme';
import { ButtonComponent } from 'shared/design-system/ui/button';
import { ColumnComponent, RowComponent } from 'shared/design-system/ui/layout';
import { TitleComponent } from 'shared/design-system/ui/typography';
import { PaddingSize } from 'shared/design-system/data-access/layout';
import { ASSET_LOCATION } from 'shared/core/data-access/file';

@Component({
    selector: 'it-dialog',
    imports: [RowComponent, ColumnComponent, ButtonComponent, TitleComponent],
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
    @Input({ required: true }) header!: string;
    @Input() disableAccept?: boolean;
    @Input({ required: true }) showCancelButton!: boolean;
    @Input() loading?: boolean;
    @Input() confirmButtonLabel?: string = $localize`:@@glossary.ok:Ok`;
    @Input() contentPadding: PaddingSize = '1.5rem';
    @Input() acceptButtonSeverity:
        | 'primary'
        | 'danger'
        | 'success'
        | 'secondary' = 'primary';
    @Input() cancelButtonOutlined?: boolean = false;
    @Input() showDeleteButton?: boolean = false;
    @Input() deleteButtonLabel?: string = $localize`:@@glossary.delete:Delete`;
    @Input() deleteLoading?: boolean = false;

    @Output() accepted = new EventEmitter<void>();
    @Output() cancelled = new EventEmitter<void>();
    @Output() deleted = new EventEmitter<void>();

    ColorEnum = ColorEnum;
    IconEnum = IconEnum;
    assetLocation = inject(ASSET_LOCATION, { optional: true });

    @HostBinding('style.--dialog-header-bg')
    get dialogHeaderBackground() {
        const imagePath =
            (this.assetLocation?.image ?? '') + 'modal-header-bg.svg';
        return `url('${imagePath}')`;
    }
}
